import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { useCurrentUser } from '@/entities/user/currentUser';

import { SBar, SFill } from './styled';

export const RecordingCredits = () => {
  const { data: minutes } = useCurrentUser((u) => u.credits?.recording_free_minutes);

  if (!minutes) return null;

  const total = Math.max(0, minutes.total);
  const used = Math.min(total, Math.max(0, minutes.used));
  const remaining = total - used;
  const fillRatio = total === 0 ? 1 : used / total;
  const fillPercent = Math.min(100, Math.max(0, fillRatio * 100));

  return (
    <Stack alignItems="center" gap="4px">
      <Typography color="grey.500" variant="body-1-md">
        {remaining} min
      </Typography>
      <SBar>
        <SFill data-testid="recording-credits-fill" style={{ width: `${fillPercent}%` }} />
      </SBar>
    </Stack>
  );
};
